<template>
  <div class="position_applicants_email_sender">
    <div>
      <p class="bold">כותרת</p>
      <input v-model="subject" class="outlined full_width">
    </div>
    <div>
      <p class="bold">אימיילים לשליחה</p>
      <position-email-text-area v-model="recipient" :position="payload.position"></position-email-text-area>
    </div>
    <div>
      <p class="bold">greetings</p>
      <textarea class="full_width" v-model="greetings"></textarea>
    </div>
    <div>
      <br>
      <br>
      <div v-html="$sanitize(payload.text)" class="applicant_infos"></div>
      <div>
        <p class="bold">קבצים שיצורפו למייל:</p>
        <div>
          <single-file v-for="file in files" :file="file" :key="file.name" :applicant="file.applicant" :show_checkbox="false" :show_edit="false"
                       :show_delete="false">
          </single-file>
        </div>
      </div>
    </div>
    <div class="vertical_space"></div>
    <div class="vertical_space"></div>
    <div class="vertical_space"></div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_submitting }"
        class="button is-info"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import TextsHelper from '@/custom/classes/texts_helper.js'
import Validator from '@/custom/classes/validator.js'
import SingleFile from '@/components/SingleFile'
import PositionEmailTextArea from '@/components/PositionEmailTextArea'
export default {
  name: 'PositionApplicantsEmailSender',
  props: ['payload'],
  data () {
    return {
      texts_helper: new TextsHelper(),
      validator: new Validator(),
      is_submitting: false,
      files: this.payload.files || [],
      subject: '',
      recipient: '',
      positionCompanyIdTextContent: '',
      greetings: 'היי,\nבהמשך לשיחתנו, מצ"ב ריכוז מועמדים רלוונטיים שנשלחו אליך על ידינו:'
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      // eslint-disable-next-line no-unused-vars
      const tests = await this.$network_utils.getResourceTexts({ current_type: 'Position', current_resource_id: this.payload.position.id })
      this.positionCompanyIdTextContent = this.payload.position.company_position_id
      this.subject = this.getTitle()
    },
    getTitle () {
      const company_position_id =
        this.positionCompanyIdTextContent
          ? ' - (משרה מספר: ' + this.positionCompanyIdTextContent + ')'
          : ''
      return `${this.$settings.get({ path: 'app_name' })}: ${this.payload.position.company.name} - ריכוז מועמדים למשרה ${this.payload.position.title}${company_position_id}`
    },
    submit () {
      if (!this.validator.validateMultipleEmails({ value: this.recipient })) {
        return
      }
      this.is_submitting = true
      let files = {}
      this.files.forEach(file => {
        if (files[file.applicant.resource_id] == undefined) {
          files[file.applicant.resource_id] = []
        }
        files[file.applicant.resource_id].push(file.name)
      })
      this.$network_utils.postEvent({
        event: 'send_offers_email',
        current_type: 'Position',
        current_resource_id: this.payload.position.id,
        owner: this.$utils.getOwner().name,
        text: this.greetings,
        offer_list: this.payload.offer_list,
        files,
        subject: this.subject,
        recipient: this.recipient
      }).then(response => {
        this.is_submitting = false
        this.$utils.emit('show_toast', { text: 'נשלח בהצלחה' })
        this.remove(this.payload)
      })
    },
    ...mapMutations('modals', ['remove'])
  },
  components: {
    SingleFile,
    PositionEmailTextArea
  }
}
</script>
<style scoped>
  .applicant_infos {
    word-break: break-word;
  }
</style>
<style>
  .position_applicants_email_sender .applicant_infos .applicant_info {
    padding-bottom: 30px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
</style>
